import { render } from "./TopMobil.vue?vue&type=template&id=27d35fb2&scoped=true"
import script from "./TopMobil.vue?vue&type=script&lang=js"
export * from "./TopMobil.vue?vue&type=script&lang=js"

import "./TopMobil.vue?vue&type=style&index=0&id=27d35fb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27d35fb2"]])

export default __exports__